export default "__VITE_ASSET__CFa4lO8S__"